import React from 'react';

import {LegendUIContext, LegendUIContextValue} from './legendUIContext';

export {LegendUIContext} from './legendUIContext';

export function LegendUIProvider({
  isLegendCollapsed,
  setIsLegendCollapsed,
  onOpenDetailsLegendInSidebar,
  children,
}: LegendUIContextValue & {children: React.ReactNode}) {
  const value = React.useMemo(
    () => ({isLegendCollapsed, setIsLegendCollapsed, onOpenDetailsLegendInSidebar}),
    [isLegendCollapsed, setIsLegendCollapsed, onOpenDetailsLegendInSidebar]
  );

  return <LegendUIContext.Provider value={value}>{children}</LegendUIContext.Provider>;
}
